module.exports = __webpack_public_path__ + "r-v3/img/ml_61_00.fe46b7fe.jpg";